<div class="modal-header">
    <h4 class="modal-title drop-modal-title" id="modal-basic-title"></h4>
    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" (click)="closeModal(false)"></button>
</div>
<div class="modal-body" style="height:{{iFrameHeight}}">
    <iframe [src]="safeUrl" width="100%" height="{{iFrameHeight}}"></iframe>
</div>
